import { useEffect } from "react"
import { BrowserRouter, Route, Routes } from "react-router-dom"

import ListOrders from "../Orders/ListOrders.js"
import ViewOrder from "../Orders/ViewOrder.js"
import CreateOrder from "../Orders/CreateOrder.js"
import EditOrder from "../Orders/EditOrder.js"




export default function Orders() {

    return (
        <Routes>
            <Route path="/" element={<ListOrders />} />
            <Route path="/view/:id" element={<ViewOrder />} />
            <Route path="/edit/:id" element={<EditOrder />} />
            <Route path="/create/" element={<CreateOrder />} />
        </Routes>
    )
}


